import { render, staticRenderFns } from "./PortionsTableRow.vue?vue&type=template&id=a2c90b42&scoped=true&"
import script from "./PortionsTableRow.vue?vue&type=script&lang=js&"
export * from "./PortionsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./PortionsTableRow.vue?vue&type=style&index=0&id=a2c90b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c90b42",
  null
  
)

export default component.exports